module.exports = __webpack_public_path__ + "static/media/terms.e6be0e0d.pdf";